import React, { useState, useCallback } from 'react';
import {
  View, Text, StyleSheet, FlatList, TouchableOpacity,
  ActivityIndicator, RefreshControl,
} from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { Ionicons } from '@expo/vector-icons';
import pilotService from '../services/pilotService';
import MissionCard from '../components/MissionCard';

export default function PilotMissionsScreen({ navigation }) {
  const [missions, setMissions]     = useState([]);
  const [loading, setLoading]       = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [tab, setTab]               = useState('active');

  const load = useCallback(async (isRefresh = false) => {
    if (isRefresh) setRefreshing(true); else setLoading(true);
    try {
      const data = await pilotService.getAllPilotMissions();
      setMissions(data);
    } catch (_) {}
    finally { setLoading(false); setRefreshing(false); }
  }, []);

  useFocusEffect(useCallback(() => { load(); }, [load]));

  const active  = missions.filter(m => m.status !== 'completed');
  const history = missions.filter(m => m.status === 'completed');
  const data    = tab === 'active' ? active : history;

  const renderItem = ({ item }) => (
    <MissionCard
      item={item}
      onPress={() => navigation.navigate('PilotMissionDetail', { item })}
    />
  );

  if (loading) {
    return (
      <View style={styles.centered}>
        <ActivityIndicator size="large" color="#2c3e50" />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <View style={styles.tabs}>
        <TouchableOpacity
          style={[styles.tab, tab === 'active' && styles.tabActive]}
          onPress={() => setTab('active')}
        >
          <Text style={[styles.tabText, tab === 'active' && styles.tabTextActive]}>
            Activas {active.length > 0 ? `(${active.length})` : ''}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.tab, tab === 'history' && styles.tabActive]}
          onPress={() => setTab('history')}
        >
          <Text style={[styles.tabText, tab === 'history' && styles.tabTextActive]}>
            Historial {history.length > 0 ? `(${history.length})` : ''}
          </Text>
        </TouchableOpacity>
      </View>

      <FlatList
        data={data}
        keyExtractor={item => item.id.toString()}
        renderItem={renderItem}
        contentContainerStyle={styles.list}
        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={() => load(true)} tintColor="#2c3e50" />}
        ListEmptyComponent={
          <View style={styles.empty}>
            <Ionicons name={tab === 'active' ? 'airplane-outline' : 'time-outline'} size={48} color="#e5e7eb" />
            <Text style={styles.emptyTitle}>
              {tab === 'active' ? 'Sin misiones activas' : 'Sin historial aún'}
            </Text>
            <Text style={styles.emptyText}>
              {tab === 'active'
                ? 'Las misiones asignadas aparecerán aquí.'
                : 'Las misiones completadas aparecerán aquí.'}
            </Text>
          </View>
        }
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container:     { flex: 1, backgroundColor: '#f5f7fa' },
  centered:      { flex: 1, justifyContent: 'center', alignItems: 'center' },
  tabs:          { flexDirection: 'row', backgroundColor: '#fff', borderBottomWidth: 1, borderBottomColor: '#f3f4f6' },
  tab:           { flex: 1, paddingVertical: 14, alignItems: 'center' },
  tabActive:     { borderBottomWidth: 2, borderBottomColor: '#2c3e50' },
  tabText:       { fontSize: 14, color: '#9ca3af', fontWeight: '500' },
  tabTextActive: { color: '#2c3e50', fontWeight: '700' },
  list:          { padding: 12 },
  empty:         { alignItems: 'center', paddingVertical: 60, paddingHorizontal: 40 },
  emptyTitle:    { fontSize: 16, fontWeight: '600', color: '#374151', marginTop: 16, marginBottom: 8 },
  emptyText:     { fontSize: 13, color: '#9ca3af', textAlign: 'center', lineHeight: 20 },
});
